module.exports = __webpack_public_path__ + "img/Postmodernisme_Andre_kunstformer10.fb56d73e.jpg";